'use strict'

import 'fslightbox'
import 'bootstrap'
import FrontendLogin from './Components/FrontendLogin'
import SwiperComponent from "./Components/SwiperComponent";
import MrFilters from './Components/MrFilters'
import Custom from './Components/Custom'
import ResponsiveNavigation from './Components/ResponsiveNavigation'

export default class Application {
  constructor () {

    this
      ._initializeFrontendLogin()
      ._initializeSwiperComponent()
      ._initializeMrFilters()
      ._initializeCustom()
      ._initializeResponsiveNavigation()

    return this
  }

  _initializeSwiperComponent() {
    (() => new SwiperComponent().enable())()

    return this
  }

  _initializeFrontendLogin() {
    (() => new FrontendLogin())()

    return this
  }

  _initializeMrFilters () {
    (() => new MrFilters().start())()

    return this
  }

  _initializeCustom () {
    (() => new Custom().addCode())()

    return this
  }

  _initializeResponsiveNavigation () {
    (() => new ResponsiveNavigation().init())()

    return this
  }
}
